import confirmDialog from "./confirmDialog"


export default class prompt {

    taskid

    constructor(taskid) {  // Constructor
        this.taskid = taskid;
    }

    async getFullPrompt(dlg) {
        let modifiers = ""
        let str=dlg.modifiers
        let list = str.split(/\n|\r/)
        let prefix=""
        let prompt=""
        try {

            for (let i = 0; i < list.length; i++) {
                let m = list[i]
                m=m.trim()
                if (m.endsWith("...") ) {
                    prefix+=m.replace("..."," ")
                }else {
                    if (m && m[0] != "#" && m[0] != "-" && !m.startsWith("lora:")) {
                        if (m.search(":") != -1)  m="("+m+")"
                        modifiers += ", " + m
                    }
                }
            }
            prompt = dlg.prompt
        } catch(e) {
            console.log(e)
        }

        if (!prompt) {
            await new confirmDialog().alert("Empty prompt","Type some text in prompt input box about what you want to see.")
            return ""
        }

        prompt=prefix+prompt
        prompt += modifiers
        return prompt
    }
    getLoraList(dlg) {
        let str=dlg.modifiers
        let list = str.split(/\n|\r/)
        let loraList=[]
        for (let i = 0; i < list.length; i++) {
            let m = list[i]
            if (m.startsWith("lora:")) {
                let url=m.replace("lora:","")
                let weight=1.0
                url=url.replace("://", "__MAGIC__")
                if (url.search(":") != -1)  {
                    let arr=url.split(":")
                    url=arr[0]
                    weight=parseFloat(arr[1])
                }
                url=url.replace("__MAGIC__", "://")
                loraList.push({url,weight})
            }
        }
        return loraList

    }
    async getNegativePrompt(dlg) {
        let negativePrompt = ""
        let str=dlg.modifiers
        let list = str.split(/\n|\r/)
        for (let i = 0; i < list.length; i++) {
            let m = list[i]
            if (m[0] === "-") negativePrompt += ", " + m.replace("-","")
        }
        return negativePrompt
    }
    async getPromptObject(dlgData,SDMode,ImageInfo,AlphaImgInfo,DepthImageInfo,specialLayersImageInfo) {
        let data=dlgData
        let p={}
        p.prompt=await this.getFullPrompt(data)
        p.negativePrompt=await this.getNegativePrompt(data)
        p.loraList=await this.getLoraList(data)

        if (!p.prompt) return
        p.mode=SDMode        
        if (p.mode==="variations") p.prompt="variations"
        p.steps=data["steps"]
        p.seed=data["seed"]
        p.num=data["num"]
        p.inpainting_original=data["inpainting_original"]
        p.sampling_method=data["sampling_method"]
        p.cfg_value=data["cfg_value"]
        if (data["clip"]) p.clip=true
        p.tiling=dlgData.tiling
        p.enable_hr=dlgData.enable_hr
        p.enable_depth=dlgData.enable_depth
        p.restore_faces=dlgData.restore_faces
        p.strength=0.75
        if (SDMode==="img2img") {
            p.strength=data["strength"]
            p.image64=ImageInfo.base64
            p.imageURLRef=ImageInfo.urlRef
            if (DepthImageInfo) p.depthImage64=DepthImageInfo.base64
        }
        if (SDMode==="variations") {
            p.image64=ImageInfo.base64
            p.imageURLRef=ImageInfo.urlRef
        }
        if (SDMode==="removeBackground") {
            p.image64=ImageInfo.base64
            p.imageURLRef=ImageInfo.urlRef
        }
        if (SDMode==="upscale") {
            p.image64=ImageInfo.base64
            p.imageURLRef=ImageInfo.urlRef
            p.upscaleEngine=dlgData.upscaleEngine
        }        
        if (SDMode==="inpainting" || SDMode==="inpainting_original") {
            p.strength=data["strength"]
            p.image64=ImageInfo.base64
            p.imageURLRef=ImageInfo.urlRef
            if (AlphaImgInfo) {
                p.maskImage64=AlphaImgInfo.base64
                p.maskURLRef=AlphaImgInfo.urlRef
            }
        }
        p.specialLayersImageInfo=specialLayersImageInfo
        if(this.taskid) p.taskid = this.taskid;
        p.targetWidth=dlgData.targetWidth
        p.targetHeight=dlgData.targetHeight

        return p
    }

}